import { supabase } from '../../../lib/supabase'
import type { AiPlayerRow } from '../../../lib/database.types'

/**
 * Fetch up to N active AI personas for a Colorful match. Personas live
 * in the same catalog we use for I'd Eat That — their color intuition
 * comes from the same bio.
 */
export async function fetchColorfulAiPlayers(limit: number): Promise<AiPlayerRow[]> {
  const { data, error } = await supabase
    .from('ai_players')
    .select('*')
    .eq('is_active', true)
  if (error) throw error
  const all = (data ?? []) as AiPlayerRow[]
  // Shuffle client-side and take N so each match feels different.
  const shuffled = all.slice().sort(() => Math.random() - 0.5)
  return shuffled.slice(0, Math.max(0, Math.min(limit, shuffled.length)))
}
